import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Phone from '../../member/components/Phone';
import Email from '../../member/components/Email';
import FormattedCurrency from '@s/FormattedCurrency';
import { DELIVERY_TYPE_EMAIL } from '../reducers/delivery';
import KioskDeliveryTitle from './KioskDeliveryTitle';
import { TranslationContext } from '../../../../checkout/config/Translations'
import {GATEWAY_TYPE_STRIPE, GATEWAY_TYPE_SQUARE, GATEWAY_TYPE_WORLDPAY, GATEWAY_TYPE_PAYPAL} from '../../../reducers/payment';
import LocalizedAddress from "../../member/components/LocalizedAddress";
import clsx from 'clsx';
import { getConfigClient } from '@b/helpers/configClient';

const DeliveryOptions = props => {

    const translate = React.useContext(TranslationContext).t;

    const onMobileFocus = e => {
        props.onMobileFocus(e, translate('checkout__phone'));
    }

    const onEmailFocus = e => {
        props.onEmailFocus(e, translate('checkout__email_address'));
    }

    const onDeliveryChange = e => {
        e.stopPropagation();
        if (props.disabled) {
          return;
        }
        props.onDeliveryChange(props.delivery_option);
    }

    const isShowDeliveryAddress = (gatewayType) => {
        //null represents ShowclixCreditCard gateway type
        return gatewayType !== null && !([GATEWAY_TYPE_STRIPE, GATEWAY_TYPE_SQUARE, GATEWAY_TYPE_WORLDPAY, GATEWAY_TYPE_PAYPAL].includes(+gatewayType));
    }

    const getDeliveryMethod = () => {
        if (!props.selected) {
            return '';
        }

        if (props.delivery_option.method_name === 'Mobile') {
            return(
                <Fragment>
                    {(props.isKioskMode && props.singularDeliveryOption) ?
                        <KioskDeliveryTitle /> : ''
                    }
                    <div className="delivery__mobile__numbers">
                        <div className="mobile-number">
                            <div className="input__control__group">
                                <Phone
                                    phone={props.phone}
                                    required={true}
                                    onPhoneChange={props.onDeliveryPhoneChange}
                                    onCountryCodeChange={props.onCountryCodeChange}
                                    focus={true}
                                    countryCode={props.countryCode}
                                    onFocus={onMobileFocus}
                                    autocomplete={!props.isKioskMode}
                                />
                                {/* <div className="input__control__group__addon mobile-number__remove">
                                    <button className="button--clear button--close" onClick={props.onPhoneClear}>
                                        <i className="icon-remove" aria-hidden="true"></i>
                                        <span className="sr-only">Remove</span>
                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        } else if (props.isKioskMode && props.delivery_option.method_name === 'Pickup' && props.singularDeliveryOption) {
          return(<div className="delivery__option__empty-state">
              {translate('checkout__tickets_available_at_will_call')}
          </div>);
        } else if (props.delivery_option.method_name === 'Pickup') {
            return(<div></div>);
        } else if (props.isKioskMode && props.singularDeliveryOption && props.delivery_option.method_name === 'Online') {

            if (props.kioskCollectCustomerEmail) {
              if (!props.email) {
                return <div className="delivery__option__empty-state">
                    {translate('checkout__tickets_sent_via_email')}
                </div>
              }
                return <div className="delivery__option__empty-state">
                    {translate('checkout__tickets_sent_to_your_email', {email:props.email})}
                </div>
            } else {
                return (
                    <Fragment>
                        <KioskDeliveryTitle />
                        <Email
                            email={props.email}
                            onEmailChange={props.onEmailChange}
                            required={true}
                            onFocus={onEmailFocus}
                        />
                    </Fragment>
                );
            }
        } else if (props.delivery_option.method_name === 'Mail') {
            if(isShowDeliveryAddress(props.gatewayType)) {
                return (
                  <div>
                    <LocalizedAddress
                      {...props.address}
                      onAddressChange={props.onAddressChange}
                      header={translate('checkout__delivery_address')}
                    />
                  </div>
                );
            }

            return (<div></div>)
        } else if (props.isKioskMode && !props.kioskCollectCustomerEmail && props.delivery_option.method_type === DELIVERY_TYPE_EMAIL) {
            return (
                <div className="delivery__mobile__numbers">
                    <Email
                        email={props.email}
                        onEmailChange={props.onEmailChange}
                        required={true}
                        onFocus={onEmailFocus}
                    />
                </div>
            );
        }
    }
    let deliveryDescription = props.delivery_option.description;
    if(deliveryDescription && deliveryDescription.startsWith('checkout__')) {
      deliveryDescription = translate(deliveryDescription);
    }

    const client = getConfigClient();

    const ListingMonetizationCheckoutAValue = !!client?.getBooleanValue('ListingMonetizationCheckoutA', false);

    const hideRadio = !props.isKioskMode && ListingMonetizationCheckoutAValue && props.single;

    return(
        <div
          className={clsx("input__radio delivery__option", {
            'input__radio--selected': props.selected,
            'input__radio--no-radio': hideRadio
          })}
          onClick={onDeliveryChange}
        >
            <div className="input__radio-wrap">
                {!hideRadio && (
                    <Fragment>
                        <div className="input__radio__input">
                            {props.isKioskMode ?
                                <div className="kiosk__delivery-input__radio">
                                    <input name="delivery" type="radio"
                                        id={props.delivery_option.method_name}
                                        value={props.delivery_option.id}
                                        checked={props.selected}
                                        readOnly
                                    />
                                    <i className={`input__radio__mask ${props.selected ? "icon-radio_on" : "icon-radio_off"}`} aria-hidden="true"></i>
                                </div>
                            :
                                <input name="delivery" type="radio"
                                    id={props.delivery_option.method_name}
                                    value={props.delivery_option.id}
                                    checked={props.selected}
                                    readOnly
                                    disabled={props.disabled}
                                />
                            }
                        </div>
                        <label className="input__radio__label" htmlFor={props.delivery_option.method_name}>
                            <div className="input__radio__label-text">{props.delivery_option.name}</div>
                            {(!props.isKioskMode || +props.price > 0) && <div className="input__radio__extra">
                                <FormattedCurrency>{props.price}</FormattedCurrency>
                            </div>}
                        </label>
                    </Fragment>
                )}
                {hideRadio && (
                    <div className="input__radio__label">
                        <div className="input__radio__label-text">{props.delivery_option.name}</div>
                        {(!props.isKioskMode || +props.price > 0) && <div className="input__radio__extra">
                            <FormattedCurrency>{props.price}</FormattedCurrency>
                        </div>}
                    </div>
                )}
            </div>
            {!props.isKioskMode && <div className="input__caption">
                {deliveryDescription}
            </div>}
            {getDeliveryMethod()}
        </div>
    );
}

DeliveryOptions.defaultProps = {
    selected: false
}

DeliveryOptions.propTypes = {
    selected: PropTypes.bool,
    delivery_option: PropTypes.object.isRequired,
    onDeliveryChange: PropTypes.func.isRequired,
    price: PropTypes.number.isRequired,
    phone: PropTypes.string,
    gatewayType: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
}

export default DeliveryOptions
